import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material";
import {FormArray, FormControl, FormGroup, Validators} from "@angular/forms";
import {MessageService} from "../../../core/services/message.service";

@Component({
	selector: 'app-dialog-meta-acao-estrategica',
	templateUrl: './dialog-meta-acao-estrategica.component.html',
	styleUrls: ['./dialog-meta-acao-estrategica.component.scss']
})
export class DialogMetaAcaoEstrategicaComponent implements OnInit {

	public titulo: string;
	public descricao: string;
	public codigo: number;
	public item: string;
	public itens_outros: Array<any>;
	public mostrar_botao_voltar: boolean = false;
	public form: FormGroup;

	constructor(public dialogRef: MatDialogRef<DialogMetaAcaoEstrategicaComponent>, @Inject(MAT_DIALOG_DATA) public data:any, private messageService: MessageService) {

	}

	ngOnInit() {
		this.dialogRef.disableClose = true;
		this.titulo = this.data.titulo;
		this.descricao = this.data.descricao;
		this.codigo = this.data.codigo;
		this.item = this.data.item;
		this.itens_outros = Array.from(this.data.itens_outros);
		this.mostrar_botao_voltar = this.data.mostrar_botao_voltar;
		this.form = new FormGroup({});
		let itens_form: Array<FormGroup> = [];
		if(!this.itens_outros || this.itens_outros.length == 0){
			this.itens_outros.push({codigo: null, descricao: null});
		}
		if(this.itens_outros && this.itens_outros.length > 0){
			this.itens_outros.forEach((outro: any) => {
				itens_form.push(new FormGroup({codigo: new FormControl(outro.codigo), descricao: new FormControl(outro.descricao, [Validators.required])}));
			});
		}
		this.form.addControl("textos", new FormArray(itens_form));
	}

	close(salvar: boolean = false): void{
		this.dialogRef.close({itens_outros: this.itens_outros, salvar: salvar});
	}

	save(): void{
		if(this.form.valid){
			let form_invalido: boolean = false;
			let form_textos: FormArray = this.form.get("textos") as FormArray;
			if(form_textos.controls.length){
				form_textos.controls.forEach((form_group: FormGroup, i: number) => {
					if(!form_group.get("descricao").value){
						form_invalido = true;
					}
				});
				if(!form_invalido) {
					form_textos.controls.forEach((form_group: FormGroup, i: number) => {
						this.itens_outros[i].codigo = form_group.get("codigo").value;
						this.itens_outros[i].descricao = form_group.get("descricao").value;
					});
				}
			}
			if(form_invalido) {
				this.messageService.showError("Preencha os campos obrigatórios");
			}else{
				this.close(true);
			}
		}else{
			this.messageService.showError("Preencha os campos obrigatórios");
		}
	}

	addCampo(): void{
		let form_textos: FormArray = this.form.get("textos") as FormArray;
		form_textos.controls.push(new FormGroup({codigo: new FormControl(), descricao: new FormControl(null, [Validators.required])}));
		this.itens_outros.push({codigo: null, descricao: null});
		setTimeout(() => {
			document.getElementById('descricao_'+ (form_textos.length - 1)).focus();
		}, 1);
	}

	removeCampo(index: number): void{
		let form_textos: FormArray = this.form.get("textos") as FormArray;
		form_textos.removeAt(index);
		let itens_outros = [];
		if(this.itens_outros.length > 0){
			this.itens_outros.forEach((item: any, i: number) => {
				if(index != i){
					itens_outros.push(item);
				}
			});
		}
		this.itens_outros = itens_outros;
	}

}
